function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.46484 49.1699C0.655176 49.1699 0 48.5147 0 47.7051V21.3379C0 20.5282 0.655176 19.873 1.46484 19.873H19.1406C19.9503 19.873 20.6055 20.5282 20.6055 21.3379V25.7324H30.957C31.7667 25.7324 32.4219 26.3876 32.4219 27.1973V44.7754C32.4219 45.5851 31.7667 46.2402 30.957 46.2402H4.39453C3.5877 46.2402 2.92969 46.8969 2.92969 47.7051C2.92969 48.5147 2.27451 49.1699 1.46484 49.1699Z",
  fill: "#80A3FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30.957 25.7324H20.6055V21.3379C20.6055 20.5282 19.9503 19.873 19.1406 19.873H16.2109V46.2402H30.957C31.7667 46.2402 32.4219 45.5851 32.4219 44.7754V27.1973C32.4219 26.3876 31.7667 25.7324 30.957 25.7324Z",
  fill: "#5C75E6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1406 28.6621H7.32422C6.51455 28.6621 5.85938 28.0069 5.85938 27.1973C5.85938 26.3876 6.51455 25.7324 7.32422 25.7324H19.1406C19.9503 25.7324 20.6055 26.3876 20.6055 27.1973C20.6055 28.0069 19.9503 28.6621 19.1406 28.6621Z",
  fill: "#F3F5F9"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1406 25.7324H16.2109V28.6621H19.1406C19.9503 28.6621 20.6055 28.0069 20.6055 27.1973C20.6055 26.3876 19.9503 25.7324 19.1406 25.7324Z",
  fill: "#E2DFF4"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M48.5352 31.5918C47.7255 31.5918 47.0703 30.9366 47.0703 30.127C47.0703 29.3188 46.4123 28.6621 45.6055 28.6621H19.1406C18.331 28.6621 17.6758 28.0069 17.6758 27.1973V2.29492C17.6758 1.48525 18.331 0.830078 19.1406 0.830078H48.5352C49.3448 0.830078 50 1.48525 50 2.29492V30.127C50 30.9366 49.3448 31.5918 48.5352 31.5918Z",
  fill: "#FF6680"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M48.5352 0.830078H33.8867V28.6621H45.6055C46.4123 28.6621 47.0703 29.3188 47.0703 30.127C47.0703 30.9366 47.7255 31.5918 48.5352 31.5918C49.3448 31.5918 50 30.9366 50 30.127V2.29492C50 1.48525 49.3448 0.830078 48.5352 0.830078Z",
  fill: "#E62E6B"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M38.2812 11.084C38.2812 12.6366 37.4317 14.1015 36.084 14.8926C35.6444 15.1563 35.3516 15.625 35.3516 16.1523C35.3516 16.9728 34.7071 17.6172 33.8867 17.6172C33.0663 17.6172 32.4219 16.9728 32.4219 16.1523C32.4219 14.922 32.9785 13.7206 33.8867 12.9004C34.2732 12.5139 34.5973 12.3438 34.6191 12.3438C35.0587 12.08 35.3516 11.6113 35.3516 11.084C35.3516 10.2636 34.7071 9.61914 33.8867 9.61914C33.0663 9.61914 32.4219 10.2636 32.4219 11.084C32.4219 11.9042 31.7774 12.5488 30.957 12.5488C30.1366 12.5488 29.4922 11.9042 29.4922 11.084C29.4922 8.65225 31.455 6.68945 33.8867 6.68945C36.3185 6.68945 38.2812 8.65225 38.2812 11.084Z",
  fill: "#F3F5F9"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8867 22.8027C34.6957 22.8027 35.3516 22.1469 35.3516 21.3379C35.3516 20.5289 34.6957 19.873 33.8867 19.873C33.0777 19.873 32.4219 20.5289 32.4219 21.3379C32.4219 22.1469 33.0777 22.8027 33.8867 22.8027Z",
  fill: "#F3F5F9"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0977 40.3809H7.32422C6.51455 40.3809 5.85938 39.7257 5.85938 38.916C5.85938 38.1063 6.51455 37.4512 7.32422 37.4512H25.0977C25.9073 37.4512 26.5625 38.1063 26.5625 38.916C26.5625 39.7257 25.9073 40.3809 25.0977 40.3809Z",
  fill: "#F3F5F9"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0977 34.5215H7.32422C6.51455 34.5215 5.85938 33.8663 5.85938 33.0566C5.85938 32.247 6.51455 31.5918 7.32422 31.5918H25.0977C25.9073 31.5918 26.5625 32.247 26.5625 33.0566C26.5625 33.8663 25.9073 34.5215 25.0977 34.5215Z",
  fill: "#F3F5F9"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M35.3516 21.3379C35.3516 20.5287 34.6957 19.873 33.8867 19.873V22.8027C34.6957 22.8027 35.3516 22.1469 35.3516 21.3379Z",
  fill: "#E2DFF4"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M38.2812 11.084C38.2812 12.6366 37.4317 14.1015 36.084 14.8926C35.6444 15.1563 35.3516 15.625 35.3516 16.1523C35.3516 16.9728 34.7071 17.6172 33.8867 17.6172V12.9004C34.2732 12.5139 34.5973 12.3438 34.6191 12.3438C35.0587 12.08 35.3516 11.6113 35.3516 11.084C35.3516 10.2636 34.7071 9.61914 33.8867 9.61914V6.68945C36.3185 6.68945 38.2812 8.65225 38.2812 11.084Z",
  fill: "#E2DFF4"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0977 37.4512H16.2109V40.3809H25.0977C25.9073 40.3809 26.5625 39.7257 26.5625 38.916C26.5625 38.1063 25.9073 37.4512 25.0977 37.4512Z",
  fill: "#E2DFF4"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0977 31.5918H16.2109V34.5215H25.0977C25.9073 34.5215 26.5625 33.8663 26.5625 33.0566C26.5625 32.247 25.9073 31.5918 25.0977 31.5918Z",
  fill: "#E2DFF4"
});

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/questionMark.d6899dbc.svg";
export { ForwardRef as ReactComponent };